module.exports = __webpack_public_path__ + "img/nt15-11-75-1.prt.ef542871.jpg";